import { motion, AnimatePresence } from "framer-motion";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { useEffect } from 'react';

const OnboardingQuestionnaire = ({
  currentQuestion,
  setCurrentQuestion,
  questions,
  step,
  setStep,
  answers,
  handleNext,
  handleAnswer,
  setQuestions,
  lead,
  user,
  loading,
}) => {
  // const { assessmentLoading } = useSelector(state => state.user);
  // const dispatch = useDispatch()
	let assessmentContent = user.assessment?.content;

  const handleBackQuestion = () => {
    if (currentQuestion > 1) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };
  const handleBack = () => {
    setStep((prev) => (prev > 1 ? prev - 1 : prev));
    handleBackQuestion();
  };
  const CustomCheckboxRadio = ({
    question,
    type = "checkbox",
    wrapperClass = "",
    labelClass = "",
    name,
    value,
    label,
    id,
    required = false,
  }) => {
    const isSelected =
      type === "checkbox"
        ? questions[currentQuestion - 1]?.selectedAnswers?.includes(
            value?.toString()
          )
        : questions[currentQuestion - 1]?.selectedAnswers?.includes(
            value?.toString()
          );

    const handleChange = () => {
      if (type === "checkbox") {
        handleAnswer(question, value, "checkbox");
      } else {
        handleAnswer(question, value, "radio");
      }
    };

    return (
      <label
        className={`custom-option d-flex ${type} ${
          isSelected ? "selected" : ""
        } ${wrapperClass}`}
      >
        <input
          type={type}
          name={name}
          id={id}
          value={value}
          checked={isSelected}
          onChange={handleChange}
          required={required}
          className="visually-hidden"
          g
        />
        {type === "checkbox" && (
          <span className="check-icon">
            {isSelected ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="24" height="24" rx="4" fill="#4A4FFF" />
                <path
                  d="M7 12.5L10.5 16L17 9"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="2"
                  y="2"
                  width="20"
                  height="20"
                  rx="4"
                  stroke="#4A4FFF"
                  stroke-width="2"
                  fill="none"
                />
                <path
                  d="M7 12.5L10.5 16L17 9"
                  stroke="#4A4FFF"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            )}
          </span>
        )}
        <span className={`text-dark fw-bold fs-5 ${labelClass}`}>{label}</span>
      </label>
    );
  };

  const containerVariant = {
    hidden: { opacity: 0, x: 60, scale: 0.98 },
    visible: {
      opacity: 1,
      x: 0,
      scale: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.08,
        duration: 0,
        ease: [0.1, 1, 0.36, 1],
      },
    },
    exit: {
      opacity: 0,
      x: -60,
      scale: 0.96,
      transition: {
        duration: 0.2,
        ease: "easeInOut",
      },
    },
  };

  const answerVariant = {
    hidden: {
      opacity: 0,
      clipPath: "inset(0 100% 0 0)",
      transition: { duration: 0.4, ease: "easeOut" },
    },
    visible: {
      opacity: 1,
      clipPath: "inset(0 0% 0 0)",
      transition: { duration: 0.5, ease: "easeInOut" },
    },
  };



    useEffect(() => {
        if (user?.assessment === null && Object.keys(lead)?.length > 0) {
          // dispatch(allActions.dashboard.startQuestionnaire(lead?.userpro.id));
        } else {
          const content = assessmentContent;
          // const content = LoginData.assessment?.content;
          for (let i = 0; i < questions.length; i++) {
            if (!content[(i + 1).toString()]) {
              setCurrentQuestion(i + 1);
              break;
            }
          }
          // setDefaultAnswersForQuestion(currentQuestion);
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.assessment]);

  return (
    <div className="card mt- px-4 d-flex justify-content-center border-0">
      <div className="card-body mt-0 d-flex  justify-content-center">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentQuestion}
            variants={containerVariant}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <motion.p
              variants={answerVariant}
              className="text-center mt-0 text-dark"
            >
              Question {currentQuestion} of {questions?.length}
            </motion.p>

            <motion.h5
              variants={answerVariant}
              className="card-title text-primary fw-bold"
              style={{ fontSize: 30 }}
            >
              {currentQuestion}. {questions[currentQuestion - 1]?.question}
            </motion.h5>

            <motion.p
              variants={answerVariant}
              className="text-muted text-center my-3 fs-5"
            >
              {questions[currentQuestion - 1]?.checkMany
                ? "Select all that are relevant"
                : "Select one."}
            </motion.p>
            {questions[currentQuestion - 1]?.answers?.map((answer) => (
              <motion.div key={answer.id} variants={answerVariant}>
                <CustomCheckboxRadio
                  question={questions[currentQuestion - 1]}
                  type={
                    questions[currentQuestion - 1]?.checkMany
                      ? "checkbox"
                      : "radio"
                  }
                  wrapperClass={
                    questions[currentQuestion - 1]?.checkMany
                      ? ""
                      : "custom-question-background d-flex justify-content-center"
                  }
                  labelClass="text-dark"
                  name="answers"
                  state={answers}
                  value={answer?.isField ? "custom" : answer.id}
                  label={answer?.answer}
                  id={`option-${answer?.id}`}
                  required={true}
                />

                {answer?.isField &&
                questions[currentQuestion - 1]?.selectedAnswers?.includes(
                  "custom"
                ) ? (
                  <input
                    className="form-control mb-4"
                    type="text"
                    placeholder="Enter your answer"
                    onChange={(e) => {
                      setQuestions(
                        (questions || []).map((q, idx) => {
                          if (q?.id === questions[currentQuestion - 1]?.id) {
                            const updatedAnswers = [
                              ...(q.selectedAnswers || []),
                            ];

                            if (updatedAnswers.length >= 2) {
                              updatedAnswers[1] = e.target.value;
                            } else {
                              updatedAnswers[1] = e.target.value;
                            }

                            return {
                              ...q,
                              selectedAnswers: updatedAnswers,
                            };
                          }
                          return q;
                        })
                      );
                    }}
                  />
                ) : null}
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>
      <p
        className="text-center text-primary fw-bold fs-6 mt-1 text-decoration-uderline cursor-pointer"
        onClick={() => handleNext(false, true)}
      >
        Skip Question
      </p>
      <div className="card-footer border-0 bg-white d-flex justify-content-center">
        {step === 1 ? (
          <div>
            <button
              disabled={
                !questions[currentQuestion - 1]?.selectedAnswers?.length > 0
              }
              className="btn btn-primary d-flex align-items-center gap-2 px-4 text-white"
              onClick={() => handleNext(false)}
            >
              Continue
               {loading ? (
                <div class="d-flex justify-content-center">
                  <div class="spinner-border spinner-border-sm" role="status"></div>
                </div>
              ) : (
                <FiArrowRight />
              )}
            </button>
          </div>
        ) : (
          <div className="d-flex justify-content-between w-100 pt-2">
            <button
              className="btn btn-outline-primary d-flex align-items-center gap-2 px-4"
              onClick={handleBack}
            >
              <FiArrowLeft /> Back
            </button>

            <button
              className="btn btn-primary d-flex align-items-center gap-2 px-4 text-white"
              onClick={() => handleNext(false)}
              style={{
                backgroundColor: "#4a4fff",
                borderRadius: "10px",
              }}
              disabled={(() => {
                const answers = questions[currentQuestion - 1]?.selectedAnswers;

                if (!answers || answers.length === 0) return true;
                if (loading) return true;

                if (answers.includes("custom")) {
                  return !answers[1];
                }

                return false;
              })()}
            >
              Next Step{" "}
              {loading ? (
                <div class="d-flex justify-content-center">
                  <div class="spinner-border spinner-border-sm" role="status"></div>
                </div>
              ) : (
                <FiArrowRight />
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OnboardingQuestionnaire;
